import { ref } from "vue";

export function useUnmute() {
  const isUnmuted = ref(false);
  const playerID = ref('');
  const volume = ref(1.0)

  const toggle = (val: boolean, vol: number, id?: string) => {

    if (val) {
      isUnmuted.value = true;
      if (!!id && playerID.value != id) {
        playerID.value = id;
      }
    } else if (playerID.value == id) {
      isUnmuted.value = false;
      playerID.value = '';
    }
    volume.value = vol;
  };

  return {
    isUnmuted,
    volume,
    playerID,
    toggle
  }
}
